module.exports = __webpack_public_path__ + "img/strategie-ueber-uns.04951d5c.jpg";